import Chart from 'chart.js/auto'
import { useEffect, useRef } from "react";

export default function PieChart() {
  const canvasRef = useRef(null);
  const chartInstance = useRef(null);

    useEffect(() => {
        if (chartInstance.current) {
            chartInstance.current.destroy(); // eski chart'ı sil
        }

        chartInstance.current = new Chart(canvasRef.current, {
            type: 'doughnut',
            data: {
                labels: [
                    '%70    Polis Bakım ve Yardım Sandığı',
                    '%20    Ankara Anonim Türk Sigorta Şirketi',
                    '%5      İstanbul Sağlık Bilimleri Üniversitesi',
                    '%5      Polis Akademisi'
                ],
                datasets: [{
                    label: 'Ortaklık Oranı %',
                    data: [70, 20, 5, 5],
                    backgroundColor: [
                    '#2e3192',
                    '#ed1c24',
                    '#cefe67',
                    '#036cc7'
                    ],
                    hoverOffset: 8
                }]
            }, 
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: "right", 
                        padding: { bottom: "10" },
                        labels: { boxWidth: 70, boxHeight: 30, font: { size: 20 } }
                    },
                    tooltip: {
                        padding: 14,
                        boxPadding: 8,
                        bodySpacing: 6,
                        cornerRadius: 8,
                        borderWidth: 2
                    }
                },
                layout: { padding: 20 }
            }
        });
    }, []);

    return (
        <canvas ref={canvasRef}  class="pie-chart-container mt-4"></canvas>
    );
}

